const prefix = '[BUYBACK][SWAP]'

export const SWAP_ERROR_MESSAGE = {
  GET_CATEGORIES: `${prefix} Error getting questions API (categories)`,
  GET_QUESTIONS: `${prefix} Error getting questions API`,
  POST_QUESTIONS: `${prefix} Error posting questions API`,
  GET_OFFER: `${prefix} Error getting offer`,
  ADD_SWAP: `${prefix} Error adding buyback to cart`,
}

export const STATUS_CODE_NO_OFFER = 204
